module.exports = __webpack_public_path__ + "media/images/admin/icons/cloud-snow-fa63d5d8aa51a66a09670839d6654bb1.svg";